import type { Dict } from "./translate";

export const zh: Dict = {
  "lang.choose": "选择语言",
  "lang.menu": "语言",

  "common.optional": "选填",
  "common.select": "请选择",
  "common.cancel": "取消",
  "common.search": "搜索{label}…",
  "common.noMatches": "没有匹配项。",
  "common.listSep": "、",

  "page.subtitle": "商户申请",
  "page.referredBy": "推荐人",
  "page.aBlogicAgent": "BLogic 代理商",
  "page.checkingLink": "正在检查您的链接…",
  "page.linkUnverifiedTitle": "无法检查此链接",
  "page.linkUnverifiedBody": "我们暂时无法确认此申请链接。请稍后刷新页面，或联系您的 BLogic 联系人寻求帮助。",
  "page.linkInvalidTitle": "链接无效",
  "page.linkInvalidBody": "此申请链接已失效。请向您的 BLogic 联系人索取新链接。",
  "page.missingDl": "请添加驾照照片。",
  "page.missingCheck": "请添加一张作废的商业支票照片。",
  "page.genericError": "出了点问题，请重试。",
  "page.startOverTitle": "重新开始？",
  "page.startOverBody": "您在此设备上填写的所有内容都将被清除，且无法恢复。",
  "page.submit": "提交申请",
  "dup.title": "您似乎已经提交过申请",
  "dup.body": "我们已于 {date} 收到 {name} 的申请。这是同一家商家吗？",
  "dup.same": "是的，是同一家——不要重复提交",
  "dup.fix": "是的，我需要修改之前的申请",
  "dup.new": "不是——这是另一个营业地点",
  "dup.replaceTitle": "替换您之前的申请？",
  "dup.replaceBody": "这份新申请将替换 {date} 提交的申请。",
  "dup.replaceConfirm": "是的，替换",
  "dup.back": "返回",
  "dup.sameDoneTitle": "已完成",
  "dup.sameDoneBody": "我们已收到您的申请，您的代理会与您联系。",
  "dup.updatedTitle": "已更新——谢谢！",
  "dup.updatedBody": "BLogic 将审核您的更改。",

  "done.title": "申请已收到",
  "done.body": "谢谢！BLogic 代表会尽快与您联系，核对您的资料并完成开户。",
  "done.reference": "参考编号：{id}",
  "done.another": "再提交一份申请",

  "step.welcome": "欢迎",
  "step.legal": "法定信息",
  "step.business": "业务",
  "step.owner": "业主",
  "step.bank": "银行",

  "wiz.back": "上一步",
  "wiz.continue": "继续",
  "wiz.submitting": "正在提交…",
  "wiz.saving": "正在保存…",
  "wiz.notSaved": "未保存",
  "wiz.saved": "已于 {time} 保存",
  "wiz.restored": "已恢复您在 {time} 保存的草稿。",
  "wiz.startOver": "重新开始",
  "wiz.tryAgain": "重试",

  "file.prompt": "拍照或上传",
  "file.scanning": "正在扫描…",
  "file.unsupported": "不支持此文件类型",
  "file.uploadedTap": "上传成功，点击可更换",
  "file.uploadedDrop": "上传成功，拖入新文件或点击浏览以更换",
  "file.dragDrop": "将文件拖放到此处，或",
  "file.browse": "浏览文件",
  "file.limits": "图片或 PDF，最大 {mb} MB",
  "file.previewAlt": "{name} 的预览",
  "file.attached": "已附加：{name}",
  "file.remove": "移除",
  "file.typeError": "不支持此文件类型，请改选支持的文件。",
  "file.oneFile": "一次只能拖入一个文件。",
  "file.tooLarge": "该文件为 {size} MB，上限为 {max} MB。请使用较小的照片或较低分辨率的扫描件。",
  "file.reupload": "请重新上传此文件。",
  "file.previousLead": "您上次附加了 {name}。照片不会保存在进度中，请重新附加。",
  "file.previousDl": "下方的姓名、出生日期和地址来自该照片。",
  "file.previousCheck": "下方的银行信息来自该照片。",

  "conv.message": "我们无法处理您的{names}。请点击重新上传。",
  "conv.pair": "{a}和{b}",
  "conv.dl": "驾照",
  "conv.check": "作废支票",

  "scan.kept": "照片已附加。我们保留了您已填写的信息。",
  "scan.firstName": "名字",
  "scan.middleName": "中间名",
  "scan.lastName": "姓氏",
  "scan.dob": "出生日期",
  "scan.address": "地址",
  "scan.city": "城市",
  "scan.state": "州",
  "scan.zip": "邮编",
  "scan.routing": "路由号码",
  "scan.account": "账号",
  "scan.bankName": "银行名称",

  "welcome.title": "欢迎来到 BLogic Systems",
  "welcome.intro": "感谢您选择与我们合作。这份简短的申请是开始收款的第一步，大约需要 5–10 分钟。",
  "welcome.need": "您需要准备",
  "welcome.need1": "企业法定名称、EIN（雇主识别号码）和地址",
  "welcome.need2": "业主的 SSN（社会安全号码）；非美国公民或居民请提供护照及签发国家；以及住址",
  "welcome.need3": "主要业主的详细信息",
  "welcome.need4": "您的企业银行账户信息",
  "welcome.start": "开始",

  "legal.title": "企业法定信息",
  "legal.subtitle": "请介绍一下您的企业。",
  "legal.legalName": "企业法定名称",
  "legal.email": "电子邮件",
  "legal.phone": "企业电话",
  "legal.website": "网站",
  "legal.street": "街道地址",
  "legal.zip": "邮编（ZIP）",
  "legal.state": "州",
  "legal.city": "城市",
  "legal.ownershipType": "企业类型",
  "legal.startDate": "企业成立日期",
  "legal.ssn": "社会安全号码（SSN）",
  "legal.ssnHint": "独资企业主请提供 SSN。9 位数字，格式为 XXX-XX-XXXX。",
  "legal.ein": "雇主识别号码（EIN）",
  "legal.einHint": "9 位数字，格式为 XX-XXXXXXX",
  "legal.dbaTitle": "DBA（经营名称）",
  "legal.dbaSubtitle": "顾客看到的店名（如与法定名称不同）。",
  "legal.dbaSame": "DBA 是否与法定名称相同？",
  "legal.dbaYes": "是，使用法定名称",
  "legal.dbaNo": "否，使用不同的 DBA",
  "legal.dbaName": "经营名称（DBA）",
  "legal.dbaNamePlaceholder": "顾客看到的店名",

  "biz.title": "业务",
  "biz.subtitle": "您的收款业务概况。",
  "biz.estimates": "交易预估",
  "biz.monthly": "每月总销售额（美元）",
  "biz.avgTicket": "平均每笔交易金额（美元）",
  "biz.maxTicket": "单笔最大交易金额（美元）",
  "biz.product": "您销售什么？",
  "biz.productPlaceholder": "简要描述您的产品或服务。",

  "owner.title": "业主信息",
  "owner.subtitle": "我们需要核实主要业主的身份。根据卡组织规定，所填业主的合计持股须至少达到 51%。",
  "owner.photoLabel": "请拍摄您的驾照照片",
  "owner.photoHint": "我们会从照片中读取您的姓名、出生日期和地址，省去您手动输入。之后请核对各栏。",
  "owner.reading": "正在读取驾照…",
  "owner.failed": "读取驾照时出错。请手动填写下方各栏。",
  "owner.nothingRead": "无法从这张照片中读取任何信息。请换一张更清晰、光线充足的照片，或手动填写下方各栏。",
  "owner.prefilled": "已自动填写{fields}。请逐项核对并更正有误之处。",
  "owner.citizenship": "公民身份",
  "owner.citizenUs": "美国公民或居民",
  "owner.citizenNonUs": "非美国人士",
  "owner.firstName": "名字",
  "owner.middle": "中间名",
  "owner.lastName": "姓氏",
  "owner.dob": "出生日期",
  "owner.jobTitle": "职务",
  "owner.ssn": "社会安全号码（SSN）",
  "owner.ssnHint": "9 位数字，格式为 XXX-XX-XXXX",
  "owner.passport": "护照号码",
  "owner.passportHint": "请按业主护照上的号码填写（字母和数字）。",
  "owner.passportCountry": "护照签发国家",
  "owner.phone": "电话",
  "owner.home": "住址",

  "bank.title": "企业银行账户",
  "bank.subtitle": "用于接收入账款项和支付交易手续费。",
  "bank.photoLabel": "请拍摄一张作废的商业支票",
  "bank.photoHint": "我们会读取支票底部的路由号码和账号。也可以使用印有银行抬头的银行证明信。",
  "bank.reading": "正在读取支票…",
  "bank.failed": "读取支票时出错。请手动输入路由号码和账号。",
  "bank.nothingRead": "无法从这张照片中读取任何信息。请换一张更清晰、光线充足的照片，或手动输入路由号码和账号。",
  "bank.prefilled": "已自动填写{fields}。请与支票核对。",
  "bank.bankName": "银行名称",
  "bank.bankNamePlaceholder": "例如 Wells Fargo",
  "bank.routing": "银行路由号码",
  "bank.routingHint": "9 位数字。",
  "bank.account": "账号",
  "bank.accountPlaceholder": "支票账户账号",
  "bank.accountHint": "仅限数字，最多 17 位。",
  "bank.accountType": "账户类型",
  "bank.separate": "使用另一个账户扣款",
  "bank.withdrawBank": "扣款银行名称",
  "bank.withdrawType": "扣款账户类型",
  "bank.withdrawRouting": "扣款账户的银行路由号码",
  "bank.withdrawAccount": "扣款账户账号",
  "bank.notes": "特别备注",
  "bank.notesPlaceholder": "还有其他需要我们了解的吗？",
  "bank.notesHint": "选填。任何您希望审核团队了解的信息。",
  "bank.privacy": "您的信息会安全传送，仅由 BLogic 代表查看。在您与他们确认资料之前，不会产生任何费用，也不会开通账户。",

  "v.required": "{label}为必填项。",
  "v.digits": "{label}必须是 {n} 位数字。",
  "v.digitsRange": "{label}必须是 {min}–{max} 位数字。",
  "v.zip": "{label}必须是 5 位数字。",
  "v.letters": "{label}只能包含字母。",
  "v.tooLong": "{label}不能超过 {max} 个字符。",
  "v.amount": "请输入有效金额。",
  "v.ownershipType": "请选择企业类型。",
  "v.emailRequired": "请填写电子邮件地址。",
  "v.emailInvalid": "请输入有效的电子邮件地址。",
  "v.title": "请选择职务。",
  "v.ssnSole": "独资企业必须提供 SSN。",
  "v.einRequired": "请提供 EIN。",
  "v.ssnRequired": "请提供 SSN。",
  "v.passportRequired": "请提供护照号码。",
  "v.passportInvalid": "请输入有效的护照号码：5–20 位字母或数字。",
  "v.passportCountryRequired": "请选择护照签发国家。",
  "v.dbaRequired": "请填写 DBA 名称，或选择“{option}”。",

  "lbl.dbaName": "DBA 名称",
  "lbl.addressLine2": "地址第 2 行",
  "lbl.dbaStreet": "DBA 街道地址",
  "lbl.dbaCity": "DBA 城市",
  "lbl.dbaState": "DBA 州",
  "lbl.dbaZip": "DBA 邮编（ZIP）",
  "lbl.contactName": "联系人姓名",
  "lbl.productDescription": "产品描述",
  "lbl.middleName": "中间名",
  "lbl.idNumber": "证件号码",
  "lbl.phoneNumber": "电话号码",
  "lbl.mcc": "MCC（商户类别代码）",
  "lbl.ein": "EIN（雇主识别号码）",
  "lbl.ssn": "SSN（社会安全号码）",

  "own.Sole Proprietorship": "独资企业",
  "own.Partnership": "合伙企业",
  "own.General Partnership": "普通合伙企业",
  "own.Limited Partnership": "有限合伙企业",
  "own.Limited Liability Partnership": "有限责任合伙企业（LLP）",
  "own.LLC": "有限责任公司（LLC）",
  "own.Corporation - Private": "股份公司（非上市）",
  "own.Corporation - Public": "股份公司（上市）",
  "own.Professional Association": "专业执业公司（PA）",
  "own.Non-Profit": "非营利组织",
  "own.Political Organization": "政治组织",
  "own.Government": "政府机构",
  "own.Trust": "信托",
  "own.Financial Institution": "金融机构",
  "own.Other": "其他",

  "title.Owner": "业主",
  "title.Co-Owner": "共同业主",
  "title.President": "总裁",
  "title.Vice President": "副总裁",
  "title.Senior Vice President": "高级副总裁",
  "title.Secretary": "秘书",
  "title.Corporate Secretary": "公司秘书",
  "title.Secretary/Treasurer": "秘书兼财务主管",
  "title.CEO": "首席执行官（CEO）",
  "title.Controller": "财务总监",
  "title.Financial Officer": "财务官",
  "title.General Manager": "总经理",
  "title.General Partner": "普通合伙人",
  "title.Limited Partner": "有限合伙人",
  "title.Manager": "经理",
  "title.Member": "成员（LLC 股东）",
  "title.Director": "董事",
  "title.Executive Director": "执行主任",

  "acct.Checking": "支票账户",
  "acct.Savings": "储蓄账户",
};
